import React, { useState } from "react";
import FarmDetailsPopup from "./FarmDetailsPopup";
import FarmSummaryCard from "./FarmSummaryCard";


const FarmerFarmAccordion = ({ farms }) => {
  const [isDetailOpen, setIsDetailOpen] = useState(false);
  const [farmId, setFarmId] = useState(null);

  const handleFarmView = (id) => {
    setFarmId(id);
    setIsDetailOpen(true);
  };

  return (
    <>
      {farms.map((farm, index) => (
        <FarmSummaryCard farmSummary={farm} handleFarmView={handleFarmView} key={index}/>
      ))}
      {isDetailOpen && farmId && (
        <FarmDetailsPopup
          farmId={farmId}
          handlePopupClose={() => setIsDetailOpen(false)}
        />
      )}
    </>
  );
};

export default FarmerFarmAccordion;
